import React, { useState, useRef } from "react";

import { format } from "date-fns";
import {
  Box,
  IconButton,
  CardActions,
  Button,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
  InputAdornment,
  MenuItem,
  CardContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { red, green } from "@material-ui/core/colors";
import {
  CheckBoxBlankOutlinedIcon,
  CloseIcon,
  ExpandMoreIcon,
} from "../../../components/common/iconography";
import { NoteType } from "../../../utils/constants";
import LocationCapacity from "../../../components/common/LocationCapacity";
import CrewCard from "../../../components/common/CrewCard";
import { CustomFieldsMobile } from "../../../components/common/CustomFields";
import PhotoManager from "../../../components/common/PhotoManager";
import { getLocationViewName } from "../../../utils/locationUtils";
import { getUnitName } from "../../../utils/loadTypeUtils";

const useStyles = makeStyles((theme) => ({
  actions: {
    display: "flex",
    justifyContent: "space-between",
  },
  skipButton: {
    marginRight: theme.spacing(2),
  },
  notes: {
    border: "0px solid rgba(0, 0, 0, .25)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
  errorButton: {
    color: red["500"],
  },
  successButton: {
    color: green["500"],
  },
}));

export default function AuditItem({
  inventory,
  handleComplete,
  handleSkip,
  isCompleted,
  setListMode,
}) {
  const classes = useStyles();
  const [currentInventory, setCurrenInventory] = useState({ ...inventory });
  const [oldQuantityPhysical] = useState(currentInventory.quantityPhysical);
  const [note, setNote] = useState();
  const [completed, setCompleted] = useState(isCompleted);
  const imgRef = useRef();

  const completeServeyItem = () => {
    if (note) {
      const newNote = {
        date: new Date(),
        by: window.appUser?.fullName,
        type: NoteType.AUDIT,
        text: note,
      };
      if (currentInventory.notes) currentInventory.notes.push(newNote);
      else currentInventory.notes = [newNote];
    }
    const newHistory = {
      type: NoteType.AUDIT,
      date: new Date(),
      by: window.appUser?.fullName,
      text:
        `Audit Inventory update|status: ${currentInventory.status} | ` +
        `quantity physical old: ${oldQuantityPhysical} | ` +
        `quantity physical new: ${currentInventory.quantityPhysical} | ` +
        `location: ${currentInventory.location}`,
    };
    if (currentInventory.history) currentInventory.history.push(newHistory);
    else currentInventory.history = [newHistory];

    currentInventory.quantityMismatch =
      currentInventory.quantityPhysical !== currentInventory.quantityOnHand;

    setListMode(true);
    handleComplete(currentInventory);
  };

  const skipServeyItem = () => {
    debugger;
    setListMode(true);
    handleSkip(currentInventory);
  };

  const handleQuantity = (event) => {
    debugger;
    let value = "";

    if (event.target.value !== "") value = Number(event.target.value);
    if (value < 0) return;
    setCurrenInventory({ ...currentInventory, quantityPhysical: value });
    setCompleted(true);
  };

  const handleLocation = (event) => {
    debugger;
    event.target.value &&
      setCurrenInventory({
        ...currentInventory,
        location: window.appUser.reloadYard.locationMap[event.target.value],
      });
  };

  const getClassName = () => {
    return !completed
      ? classes.button
      : currentInventory.quantityPhysical === currentInventory.quantityOnHand
        ? classes.successButton
        : classes.errorButton;
  };

  const handleCancel = () => {
    setListMode(true);
  };

  const getNoteText = (note) => {
    return `${format(new Date(note.date), "MM/dd/yyyy hh:mm a")} by ${
      note.by
    }: ${note.text}`;
  };

  const getAreaLocations = () =>
    window.appUser.reloadYard.locations.items
      .filter((itm) => itm.areaId === currentInventory.location.areaId)
      .map((location) => (
        <MenuItem key={location.id} value={location.id}>
          {getLocationViewName(location)}
        </MenuItem>
      ));

  return (
    <div ref={imgRef}>
      <CrewCard
        title={currentInventory.productName}
        icon={<CheckBoxBlankOutlinedIcon fontSize="large" />}
        subheader={getLocationViewName(currentInventory.location)}
        action={
          <IconButton edge="start" onClick={handleCancel}>
            <CloseIcon fontSize="large" />
          </IconButton>
        }
        showDivider={false}
      >
        <CardContent>
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12}>
              <PhotoManager parentId={inventory.id} viewOnly={true} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Typography>Account: {currentInventory.accountName}</Typography>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Typography>Lot number: {currentInventory.lotNumber}</Typography>
            </Grid>
            <Grid item xs={12}>
              <CustomFieldsMobile
                recordFields={currentInventory?.customFields}
                accountFields={currentInventory?.account.outboundCustomFields}
                width={6}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                name="quantityPhysical"
                label="Quantity Physical"
                id="outlined-margin-dense"
                helperText={
                  !completed ||
                  currentInventory.quantityPhysical ===
                    currentInventory.quantityOnHand
                    ? ""
                    : "Quantity entered doesn't match quantity onhand"
                }
                error={
                  !completed ||
                  currentInventory.quantityPhysical ===
                    currentInventory.quantityOnHand
                    ? false
                    : true
                }
                value={completed ? currentInventory.quantityPhysical : ""}
                autoFocus
                margin="dense"
                type="number"
                fullWidth
                required
                variant="outlined"
                style={{ minWidth: "33%" }}
                onChange={handleQuantity}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {" "}
                      {getUnitName(currentInventory.inventoryUOM)}{" "}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            {currentInventory.productCode && (
              <Grid item sm={6} xs={12}>
                <Typography>
                  Product code: {currentInventory.productCode}
                </Typography>
              </Grid>
            )}
            <Grid item sm={6} xs={12}>
              <TextField
                id="location"
                select
                margin="dense"
                label="Location"
                value={currentInventory.location.id}
                variant="outlined"
                style={{ minWidth: "33%" }}
                fullWidth
                onChange={handleLocation}
              >
                {getAreaLocations()}
              </TextField>
            </Grid>
            {currentInventory.location && (
              <Grid item sm={6} xs={12}>
                <LocationCapacity location={currentInventory.location} />
              </Grid>
            )}
            <Grid item sm={12} xs={12}>
              <TextField
                name="notes"
                id="outlined-multiline-static"
                label="Notes"
                multiline
                minRows={3}
                margin="dense"
                variant="outlined"
                fullWidth
                onBlur={(evt) => evt.target.value && setNote(evt.target.value)}
              />
            </Grid>
            {
              <Grid item sm={12} xs={12}>
                <Accordion className={classes.notes}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.heading}>
                      Previous notes
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div>
                      {currentInventory.notes &&
                        currentInventory.notes
                          .map((note, idx) => (
                            <div key={idx}>
                              <Typography color="textSecondary" gutterBottom>
                                {getNoteText(note)}
                              </Typography>
                            </div>
                          ))
                          .reverse()}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            }
          </Grid>
        </CardContent>
        <CardActions className={classes.actions}>
          <div>
            <Button
              type="submit"
              className={getClassName()}
              onClick={completeServeyItem}
              onSubmit={completeServeyItem}
              color="primary"
              size="large"
            >
              Complete
            </Button>
            <Button
              onClick={skipServeyItem}
              className={classes.skipButton}
              size="large"
            >
              Skip Item
            </Button>
          </div>
          <Button onClick={handleCancel} size="large">
            Cancel
          </Button>
        </CardActions>
      </CrewCard>
    </div>
  );
}
